// src/config.js
const config = {
    hostname: "https://www.fabmisr.com.eg",
    encryptionKey: "J8X7KqP9mN2vL5tR3wY6zB4gH1jK0sA8dF5xC9eU7iO=",

  };
  export default config;
  